import { useQuery } from "@tanstack/react-query";

import { useAgentSdk } from "@/sdk";

import type { ChatTask } from "./chatTask";
import type { ChatMessage } from "./types";

import { selectChatMessages, useChatStore } from "./chat.store";

// TODO: Re-evaluate race condition fix for Amazon Connect — was previously gated on TwilioChatTask instanceof check
const isTaskRaceConditionFixEnabled = (_activeChatTask: ChatTask) => false;

/**
 * Hook to get sorted messages for the active chat task.
 * Uses a selector to only re-render when this specific chat's messages change,
 * preventing unnecessary re-renders when other chats update.
 */
export function useActiveChatMessages(activeChatTask: ChatTask): ChatMessage[] {
    const agentSdk = useAgentSdk();
    const messages = useChatStore(selectChatMessages(activeChatTask.chatId));

    // TODO:// find a way to call getMessages within creation of new task (currently doesn't work bc of race-condition)
    useQuery({
        queryKey: ["useActiveChatMessages", activeChatTask.chatId, activeChatTask.id],
        queryFn: async () => {
            // getMessages updates the store and returns messages - return value prevents React Query undefined error
            return await agentSdk.getMessages(activeChatTask);
        },
        enabled: messages.length === 0 && isTaskRaceConditionFixEnabled(activeChatTask),
        staleTime: 1000 * 60 * 1, // 1 minutes - allows retry if initial fetch fails
    });

    return messages;
}
